import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { RadioButton } from '_components';


class DBRadioButton extends React.Component {

    updateField() {
        if (this.props.selected) {
            this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field);
        } else if (this.props.type === 'int') {
            this.props.updateIntField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, this.props.selectedValue);
        } else if (this.props.type === 'bit') {
            this.props.updateBitField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, this.props.selectedValue);
        } else {
            this.props.updateTextField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, this.props.selectedValue);
        }

        if (this.props.onClick) {
            if (this.props.selected) {
                this.props.onClick(undefined);
            } else {
                this.props.onClick(this.props.selectedValue);
            }
        }
    }

    render() {
        return (
            <RadioButton
                title={this.props.title}
                size={this.props.size}
                className={this.props.className}
                selected={this.props.selected}
                label={this.props.label}
                onClick={() => this.updateField()}
            />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        updateTextField: bindActionCreators(noteActions.updateTextField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    var type = state.entities.masterData.PTERONOTESCHEMA[ownprops.entity + '.' + ownprops.field].DATA_TYPE;
    var selected = undefined;
    if( type === 'int' || type === 'bit' ) {
        selected = state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] === ownprops.selectedValue ? true : false;
    } else {
        var tmp = state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field];
        selected = tmp && tmp.trim() === ownprops.selectedValue ? true : false;
    }
    return {
        selected,
        type
    };
}

const connectedDBRadioButton = connect(mapStateToProps, mapDispatchToProps)(DBRadioButton);
export { connectedDBRadioButton as DBRadioButton };